module.exports = __webpack_public_path__ + "img/Res_Mus_3kl.41d1d58a.jpg";